import { authHttp } from '../http'
import { errorHandler } from '../../../util/error.service'
import {
  urlCalcularQtePalletPorArea,
  urlCalcularQtePalletPorAreaMetrica,
  urlQtePalletPorArea,
} from '../../routes/picking.routes'

export async function getQtePalletPorArea(picking_id) {
  try {
    const response = await authHttp().get(urlQtePalletPorArea(picking_id))
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function postQtePalletPorArea(picking_id, qtePalletsPorArea) {
  try {
    const response = await authHttp().post(urlQtePalletPorArea(picking_id), { qtePalletsPorArea })
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function calcularQtePalletPorArea(picking_id) {
  try {
    const response = await authHttp().get(urlCalcularQtePalletPorArea(picking_id))
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function calcularQtePalletPorMetrica(picking_id, valor, tipo) {
  try {
    const response = await authHttp().post(urlCalcularQtePalletPorAreaMetrica(picking_id), {
      valor,
      tipo,
    })
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}
